import type { CityItem } from '#shared/types/city'

import { computed } from 'vue'

import { useRegion } from '~/composables/useRegion'
import { useCities } from '~/composables/useRepoApi'

// Город текущего региона (cities.slug = код региона). Если город снят с публикации,
// остаётся город по умолчанию.
export const useActiveCity = () => {
  const { data: citiesData } = useCities()
  const region = useRegion()

  return computed<CityItem | undefined>(() => {
    const cityItems = citiesData.value ?? []

    const regionCity = cityItems.find((cityItem: CityItem) => {
      return cityItem.slug.trim().toLowerCase() === region.value
    })

    if (regionCity) {
      return regionCity
    }

    const defaultCity = cityItems.find((cityItem: CityItem) => cityItem.is_default)
    return defaultCity ?? undefined
  })
}
